import { all, fork } from 'redux-saga/effects';
import { ArticleSectionSaga } from './ArticleSection';

export default function* () {
  yield all([
    fork(ArticleSectionSaga)
  ]);
}
